import { Badge, List, Skeleton } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import EllipseDot from 'components/icons/EllipseDot'
import {
  BottomFLex,
  ButtonFlex,
  FlexWrapper,
  InfoWrap,
  LightText,
  NotifyDiv,
  NotifyTexBold,
  NotifyText,
} from 'modules/Page/Components/Partials/NotificationDrawer/AllNotificationDetails/style'
import moment from 'moment'
import React, { Fragment, useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useNavigate } from 'react-router-dom'

const NotificationDetails = ({
  notificationData,
  notification,
  setNotification,
  notificationAsRead,
  loading,
  hasMoreData,
  setHasMoreData,
  listData,
  pageNo,
  setPageNo,
}) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (listData?.length) {
      let payload = {
        notificationId: notificationData?.list[0]?._id,
      }
      if (!notificationData?.list[0]?.is_read) {
        notificationAsRead(payload)
      }
    }
  }, [listData])

  const fetchMoreData = () => {
    if (notificationData?.totalPages == pageNo) {
      setHasMoreData(false)
      return
    }
    if (notification) {
      setPageNo(prev => prev + 1)
    }
  }
  const pageNavigate = navLink => {
    setNotification(false)
    let params = ''
    if (Object.keys(navLink?.parameters).length) {
      Object.keys(navLink?.parameters).forEach(val => {
        params = `${params}${val}=${navLink?.parameters[val]}&`
      })
      params = params.substring(0, params.length - 1)
    }
    let route = navLink?.route
    if (params) {
      route = `${navLink?.route}?${params}`
    }
    navigate(route)
  }

  return (
    <NotifyDiv>
      <InfiniteScroll
        dataLength={listData?.length}
        next={fetchMoreData}
        hasMore={hasMoreData}
        loader={
          hasMoreData ? (
            <Skeleton avatar paragraph={{ rows: 2 }} active />
          ) : null
        }
        height={'80vh'}
      >
        <List
          bordered={false}
          dataSource={listData}
          loading={loading}
          renderItem={(item, index) => (
            <Fragment key={index + 'infinity'}>
              <List.Item>
                <FlexWrapper key={index + 'wrapper'} row>
                  <Badge dot={!item?.is_read} offset={[-10, 5]}>
                    <Avatar
                      title={item?.is_read ? '' : 'New'}
                      background="#F2F3F5"
                      src={item?.icon}
                      size={46}
                      IconName={item?.issuer?.charAt(0)?.toUpperCase()}
                    />
                  </Badge>
                  <InfoWrap column>
                    <NotifyText>
                      {!!item?.issuer && (
                        <NotifyTexBold>'{item?.issuer}'</NotifyTexBold>
                      )}
                      {!!item?.body && `  ${item?.body}`}
                    </NotifyText>
                    {!!item?.actions?.length && (
                      <ButtonFlex>
                        {item?.actions?.map((data, index) => (
                          <Button.Primary
                            text={data?.name}
                            height={'32px'}
                            key={index + data?.name}
                            onClick={() => pageNavigate(data)}
                          />
                        ))}
                      </ButtonFlex>
                    )}
                    <BottomFLex alignCenter>
                      <LightText>
                        {moment(item?.created_at).fromNow(true)} ago
                      </LightText>
                      <EllipseDot />
                      <LightText>{item?.tag}</LightText>
                    </BottomFLex>
                  </InfoWrap>
                </FlexWrapper>
              </List.Item>
            </Fragment>
          )}
        />
      </InfiniteScroll>
    </NotifyDiv>
  )
}

export default NotificationDetails
